// lib/access/analystAccess.ts
import type { UserContext } from '#types/types';

/**
 * Analyst is an asset-manager tool, so it rides on canAccessAssetManagement alone.
 *
 * It used to admit canAccessLeasing too, for the ANA-002 pilot's shared rent rolls. That put
 * the tool in front of 56 of 67 accounts, across two client organisations, while the flag
 * carrying the decision was still named after asset management: the gate read as 7 users and
 * behaved as 56. Widen this again only with a permission that says what it grants.
 */
export function canAccessAnalyst(
  user: (Pick<UserContext, 'permissions'> & { isFaterAdmin?: boolean; isFaterOrgMember?: boolean }) | null | undefined,
): boolean {
  // Every Fater user has it (owner, 2026-09-28: 'available for all Fater users obviously'). The
  // server's caller carries isFaterAdmin, the client's context isFaterOrgMember too.
  return Boolean(user?.permissions?.canAccessAssetManagement || user?.isFaterAdmin || user?.isFaterOrgMember);
}

export function canEditAnalystWorkbook(
  user: { dbUserId: string | null; isImpersonating: boolean },
  assignedOwnerIds: readonly string[] | undefined,
): boolean {
  return Boolean(user.dbUserId && !user.isImpersonating && assignedOwnerIds?.includes(user.dbUserId));
}
